export enum StreetPavingTypeEnum {
  StonePavement,
  OrnamentalPavement,
  FullGround,
  Asphalt,
  Concrete,
  Other,
  Cobblestones,
  PebbleStone,
}
